export class Configuration {
    // public static url = '';
    public static url = 'https://quiz.lohebartar.ir';
}
